/** 商行健康度 - Redux action 类型 */

// 设置查询条件
export const STALL_HEALTH_SET_FILTERS = 'STALL_HEALTH_SET_FILTERS';
// 设置列表数据（含 total）
export const STALL_HEALTH_SET_LIST = 'STALL_HEALTH_SET_LIST';
// 设置分页
export const STALL_HEALTH_SET_PAGINATION = 'STALL_HEALTH_SET_PAGINATION';
// 设置加载状态
export const STALL_HEALTH_SET_LOADING = 'STALL_HEALTH_SET_LOADING';
// 重置查询条件与分页
export const STALL_HEALTH_RESET = 'STALL_HEALTH_RESET';
